const siteMode = (process.env.REACT_APP_SITE_MODE || 'tenant').toLowerCase();

const siteConfig = {
  mode: siteMode === 'global' ? 'global' : 'tenant',
  slug: process.env.REACT_APP_SITE_SLUG || (siteMode === 'global' ? 'main' : 'tenant'),
  name: process.env.REACT_APP_SITE_NAME || (siteMode === 'global' ? 'Main Admin' : 'Tenant Site')
};

siteConfig.isGlobal = siteConfig.mode === 'global';
siteConfig.isTenant = siteConfig.mode === 'tenant';

export const isPlatformAdmin = (user) => {
  return Boolean(user && user.role === 'admin' && user.accessLevel === 'global');
};

export const canUseInputs = (user) => {
  return ['admin', 'tax_manager'].includes(user?.role);
};

export const canUseManage = (user) => {
  return user?.role === 'admin';
};

export const canViewPlatformAdmin = (user, site = siteConfig) => {
  return Boolean(site?.isGlobal && isPlatformAdmin(user));
};

export default siteConfig;
